(ns app.front.view.navigation
  (:require [app.front.util :as futil]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub]]
            [core.front.href :as href]
            [core.front.icons :as i]
            [core.front.media-query :as media-query]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))


(rf/reg-event-fx
  ::scroll-to-top
  (fn [_ _]
    (futil/scroll-to-top)))


(rf/reg-event-fx ::scroll-to-bottom
  (fn [_ _]
    (futil/scroll-to-bottom)))


(rf/reg-event-fx
  ::scroll-to-id
  (fn [_ [_ id]]
    (futil/scroll-to-id id)
    {}))


(def sub-matches
  {:view/workspace-application      :view/workspace
   :view/workspace-archiving        :view/workspace
   :view/workspace-execution        :view/workspace
   :view/workspace-pre-consultation :view/workspace})

(defn dashboard-nav-item [{:keys [tr]}]
  [:dashboard nil [:a
                   {:href (href/href :dashboard nil)}
                   [cc/icon {:icon        i/house
                             :description (tr [:dashboard-link-text])}]]])

(defn hide-breadcrumb? [match]
  (or (-> match :data :hide-breadcrumb?)
      ;; hide breadcrumb if page was linked from the wizard
      (-> match :parameters :query :wizard)))


(defn breadcrumb [{:keys [match class-name tr tr-quiet]}]
  (let [tr               (or tr (<sub [:tr]))
        tr-quiet         (or tr-quiet (<sub [:tr/quiet]))
        route-ctx        (util/mmap tr match)
        params           (-> match :parameters :path)
        {:keys [fallback
                items]}  (-> match :data :breadcrumb)
        route-name       (-> match :data :name)
        bc-items         (->> items
                              (keep (fn [make-breadcrumb-or-route-kw]
                                      (cond
                                        (fn? make-breadcrumb-or-route-kw)
                                        (make-breadcrumb-or-route-kw route-ctx)
                                        (keyword? make-breadcrumb-or-route-kw)
                                        [make-breadcrumb-or-route-kw params (tr [make-breadcrumb-or-route-kw])]
                                        :else
                                        nil)))
                              (remove nil?))
        items            (->> (concat
                                ;; from :breadcrumb route config
                                bc-items
                                (when-not (= (-> bc-items last first) route-name)
                                  [(if fallback
                                     (fallback route-ctx)
                                     (when-let [route-text (tr-quiet [route-name])]
                                       [(-> match :data :name) params route-text]))]))
                              (remove (some-fn nil?
                                               (fn [[_ _ text]] (nil? text)))))
        current-view     (get-in match [:data :name])]
    (when (and (not (hide-breadcrumb? match))
               (-> items count (> 1)))
      (into
        (cc/breadcrumb (merge {:no-trailing-slash true}
                              (when class-name (util/mmap class-name))))
        (for [[view params text query] items
              :let                     [current? (= view (get sub-matches current-view current-view))
                                        href     (href/href view params query)]]
          (when (or current? href)
            (cc/breadcrumb-item
              (p/assoc-if
                {:href            (if current? "#" href)
                 :is-current-page current?}
                :aria-current (when current? :page))
              text)))))))


(defn back-to-button [url content id]
  (cc/button
    {:id      id
     :data-cy id
     :kind    :ghost
     :size    :small
     :href    url}
    content))


(defn responsive-back-to-button [url sm-content md-content id]
  (let [md-screen? (<sub [::media-query/breakpoint-matches? :md])]
    (back-to-button url (if md-screen? md-content sm-content) id)))


(defn back-to-dashboard-button [tr]
  [back-to-button (href/href :dashboard) (tr [:back-to-dashboard]) "return-to-dashboard-button"])
